import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import SupplierModal from "../../core/modals/suppliers/SupplierModal";
import { fetchSuppliers, deleteSupplierThunk } from "../../core/redux/slices/supplierSlice";

const SupplierList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.suppliers);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchSuppliers()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((s) =>
      !q || s.supplierName?.toLowerCase().includes(q) || s.mobileNumber?.includes(q) || s.contactPersonName?.toLowerCase().includes(q)
    );
  }, [list, search]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchSuppliers()); };

  const columns = [
    { title: "Supplier Name", dataIndex: "supplierName", sorter: (a, b) => a.supplierName.localeCompare(b.supplierName) },
    { title: "Contact Person", dataIndex: "contactPersonName" },
    { title: "Mobile", dataIndex: "mobileNumber", width: 130 },
    { title: "Email", dataIndex: "email" },
    { title: "GST No.", dataIndex: "gstNumber", width: 140 },
    { title: "Status", dataIndex: "status", width: 90,
      render: (v) => <span className={`badge bg-${v === "Active" ? "success" : "danger"}`}>{v}</span> },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="edit-delete-action d-flex">
          <button className="me-2 p-2 btn btn-sm" onClick={() => openEdit(rec)}><Edit size={15} /></button>
          <button className="p-2 btn btn-sm text-danger" onClick={() => confirmDelete(() => dispatch(deleteSupplierThunk(rec.id)), rec.supplierName)}>
            <Trash2 size={15} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Suppliers" subtitle="Manage supplier records" onAdd={openAdd} addLabel="Add Supplier" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-input">
                <input type="text" placeholder="Search by name, mobile, contact..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <SupplierModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default SupplierList;
